import Unassigned from './container';

export default Unassigned;
